import styled from "styled-components";



export const InfoContainer = styled.div`
	background: #077adceb 0% 0% no-repeat padding-box !important;
  opacity: 1;

	@media screen and (max-width: 768px) {
		padding: 0 0;
	}

`;
export const Swiper = styled.div`
  background-color: blue !important;
	background: #077adceb 0% 0% no-repeat padding-box;
  opacity: 1;

	@media screen and (max-width: 768px) {
		padding: 0 0;
	}

`;
export const SwiperSlide = styled.div`
  background-color: blue !important;
	background: #077adceb 0% 0% no-repeat padding-box;
  opacity: 1;

	@media screen and (max-width: 768px) {
		padding: 0 0;
	}

`;

export const InfoWrapper = styled.div`
	display: grid;
	z-index: 1;
	height: 800px;
	width: 100%;
	max-width: 1100px;
	margin-right: auto;
	margin-left: auto;
	justify-content: center;
`;

export const InfoRow = styled.div`
	display: grid;
  width: 100%;
	grid-auto-columns: minmax(auto, 1fr);
	grid-template-areas:  'col2 col1';

	@media screen and (max-width: 768px) {
		grid-template-areas:  'col2' 'col1';
    text-align: -webkit-center;
    justify-items: center;
	}
`;

export const Column1 = styled.div`
	margin-bottom: 15px;
	padding: 0 15px;
	grid-area: col1;
  margin-top: 100px;
  @media screen and (max-width: 768px) {
		margin: 0;
    text-align-last: left;
    margin-left: 3rem;
    padding: 0;
	}
`;

export const Column2 = styled.div`
	margin-bottom: 15px;
  margin-top: 150px;
	padding: 0 15px;
	grid-area: col2;
  @media screen and (max-width: 768px) {
		margin-top: 0;
	}
`;
export const TextWrapper = styled.div`
	max-width: 540px;
	margin-left: 4rem;
  @media screen and (max-width: 768px){
    margin: 0;
    display: grid;
    justify-content: center;
	}
  @media screen and (max-width: 480px){
    margin: 0;
    display: grid;
    justify-content: left;
	}
`;

export const TopLine = styled.p`
	color: #383838;
	font-size: 16px;
  max-width: 350px;
	line-height: 16px;
	font-weight: bold;
	text-transform: uppercase;
	margin-bottom: 16px;
  text-align: left;
  letter-spacing: -0.53px;
  @media screen and (max-width: 768px){
		font-size: 15px;
	}
`;

export const Heading = styled.h1`
	margin-bottom: 5rem;
	font: normal  normal bold 30px 'Spoqa Han Sans Neo';
	line-height: 1.1;
  width: 318px;
  color: #f2f7fb;
	@media screen and (max-width: 768px){
		font-size: 24px;
    margin-bottom: 1.8rem;
	}
	@media screen and (max-width: 480px){
		font-size: 24px;
    margin-bottom: 1.8rem;
	}
`;

export const Subtitle = styled.p`
	max-width: 440px;
	font-size: 18px;
  color: #fff;
  font-weight: 300;
	line-height: 24px;
  opacity: 0.6;
  @media screen and (max-width: 768px){
		font-size: 15px;
	}
  @media screen and (max-width: 480px){
		font-size: 13px;
    font: -webkit-control;
	}
`;

export const Boldtitle = styled.p`
	max-width: 440px;
	margin-bottom: 10px;
  text-align: left;
  font-weight: 500;
  font-size: 22px;
	line-height: 24px;
  color: #fff;
  @media screen and (max-width: 768px){
		font-size: 18px;
    text-align:left;
    margin: 0;
    font-weight: 400;
	}
  @media screen and (max-width: 480px){
		font-size: 15px;
    text-align:left;
    margin: 0;
    font-weight: 400;
	}
`;

export const NumberFlex = styled.div`
  display: flex;
  margin-bottom: 5rem;
  @media screen and (max-width: 768px){
    margin-bottom: 1rem;
    margin-left: 3rem;
	}
  @media screen and (max-width: 480px){
    margin-bottom: 1rem;
    margin-left: 0rem;
	}
`
export const Number = styled.div`
	margin-bottom: 24px;
	font-size:  64px ;
	line-height: 0.8;
  margin-right: 1rem;
  font-weight: lighter;
  font-family: 'Spoqa Han Sans Neo', 'sans-serif';
  color: #fff;
	@media screen and (max-width: 768px){
		font-size: 28px;
	}
	@media screen and (max-width: 768px){
		font-size: 28px;
    line-height: inherit;
	}
`;
export const FirstNumber = styled.text`
  opacity: 0.6;
`;

export const BtnWrap = styled.div`
	display: flex;
	justify-content: flex-start;
`;

export const ImgWrap =styled.div`
	max-width: 240px;
  max-height: 550px;
  margin-right: 5px;
`;

export const Img = styled.img`
  margin-top: 5px;
  width: 220px;
  margin-left: 9.2rem;
  border-radius: 25px;
  @media screen and (max-width: 768px){
		margin-left: 1rem;
    margin-top: 2rem;
    margin-bottom: 25px;
    width: 185px;
	}
`;
export const Img1 = styled.img`
  width: 240px;
  margin-left: 9.35rem;
  margin-top: 9rem;
  position: absolute;
  z-index: 5;
  @media screen and (max-width: 768px){
    margin-left: -95px;
    margin-top: 1.8rem;
    margin-bottom: 15px;
    width: 200px;
	}
`;